// ----------------------------------------------------------------------

const account = {
  displayName: 'Alireza Hassannejad',
  email: 'theezzaco@gmail.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
